import { render, staticRenderFns } from "./DashboardFlyer.vue?vue&type=template&id=5116a0f8&"
import script from "./DashboardFlyer.vue?vue&type=script&lang=js&"
export * from "./DashboardFlyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports